import { useMemo } from 'react'
import { useLocalStorage } from 'react-use'
import { MapType } from '~/components/map/mapContext'
import { Layer, SpaceChildrenItem } from '~/packages/general/variable/spaceTime.types'
import { Map3DOption } from '../rightButtonsTopBox.component'

interface useMenuControlsProps {
  baseLayers: Layer[]
  layers: Layer[]
}

export function useMenuControls({ baseLayers, layers }: useMenuControlsProps) {
  const [mapType, setMapType] = useLocalStorage<MapType>('mapType', 'roadmap')
  const [map3DOption, setMap3DOption] = useLocalStorage<Map3DOption>('map3DOption', 'off')

  const is3D = useMemo(
    () =>
      map3DOption === 'on' ||
      (map3DOption === 'whenNecessary' &&
        layers.some(layer => (layer.space as SpaceChildrenItem).childrenItemView === 'arc')),
    [baseLayers, layers, map3DOption],
  )

  return { is3D, map3DOption, setMap3DOption, setMapType, mapType }
}
